(function () {
  'use strict';
  const root = document.getElementById('easyway-product');
  if (!root) return;
  root.querySelectorAll('.ew-thumb').forEach(button => button.addEventListener('click', () => {
    const image = root.querySelector('#ew-main-image');
    image.src = button.dataset.image;
    image.alt = button.dataset.alt;
    root.querySelector('#ew-image-link').href = button.dataset.full;
    root.querySelectorAll('.ew-thumb').forEach(item => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
  }));

  const offer = root.querySelector('[data-ew-offer]');
  if (offer && offer.querySelector('.ew-countdown')) {
    const deadline = Date.parse(offer.dataset.endsAt);
    let timer;
    function tickOffer() {
      const remaining = Math.max(0, deadline - Date.now());
      if (remaining === 0) {
        clearInterval(timer);
        offer.querySelector('.ew-offer-badge').textContent = 'Regular standalone battery price';
        ['.ew-offer-net','.ew-offer-regular','.ew-countdown','.ew-offer-deadline','.ew-offer-scope','.ew-offer-saving-row','.ew-offer-stock','.ew-countdown-heading','.ew-offer-cta'].forEach(selector => { const item=offer.querySelector(selector); if(item) item.hidden=true; });
        const ended=document.createElement('p'); ended.className='ew-offer-ended'; ended.textContent='The introductory offer has ended. Regular price: €1,850 + VAT.'; offer.append(ended);
        root.querySelectorAll('.ew-price .sb-vat-price>.sb-vat-inc,.ew-final .sb-vat-price>.sb-vat-inc').forEach(item=>item.textContent='€2,275.50');
        root.querySelectorAll('.ew-price .sb-vat-price>.sb-vat-ex,.ew-final .sb-vat-price>.sb-vat-ex').forEach(item=>item.textContent='€1,850.00');
        const schema=root.parentElement.querySelector('script[type="application/ld+json"]');
        if(schema){try{const data=JSON.parse(schema.textContent);if(data.sku==='EWAY-UNIV16WP'){data.offers.price=2275.50;delete data.offers.priceValidUntil;schema.textContent=JSON.stringify(data);}}catch(_){}}
        return;
      }
      const secs=Math.floor(remaining/1000);
      [['days',Math.floor(secs/86400)],['hours',Math.floor(secs/3600)%24],['minutes',Math.floor(secs/60)%60],['seconds',secs%60]].forEach(([key,value])=>{offer.querySelector('[data-ew-'+key+']').textContent=String(value).padStart(2,'0');});
    }
    tickOffer();
    if(Date.now()<deadline) timer=setInterval(tickOffer,1000);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden && !offer.querySelector('.ew-offer-ended'))tickOffer();});
  }

  const info = root.querySelector('.ew-offer-info');
  if (info) {
    const button=info.querySelector('#ew-offer-info-button');
    const panel=info.querySelector('#ew-offer-info-panel');
    let pinned=false;
    function showInfo(open){panel.hidden=!open;button.setAttribute('aria-expanded',String(open));}
    button.addEventListener('click',()=>{pinned=!pinned;showInfo(pinned);});
    info.addEventListener('pointerenter',()=>{if(window.matchMedia('(hover:hover)').matches)showInfo(true);});
    info.addEventListener('pointerleave',()=>{if(!pinned&&!info.contains(document.activeElement))showInfo(false);});
    info.querySelector('.ew-offer-info-close').addEventListener('click',()=>{pinned=false;showInfo(false);button.focus();});
    document.addEventListener('click',event=>{if(!info.contains(event.target)){pinned=false;showInfo(false);}});
    info.addEventListener('keydown',event=>{if(event.key==='Escape'){pinned=false;showInfo(false);button.focus();event.preventDefault();}});
    info.addEventListener('focusout',()=>{setTimeout(()=>{if(!pinned&&!info.contains(document.activeElement))showInfo(false);},0);});
  }
  let compatibility = {};
  try { compatibility = JSON.parse(document.getElementById('ew-compat-data').textContent); } catch (_) {}
  const brand = root.querySelector('#ew-inverter-brand');
  const model = root.querySelector('#ew-inverter-model');
  const result = root.querySelector('#ew-compat-result');
  function update() {
    const selected = brand.value;
    const info = compatibility[selected];
    const title = document.createElement('strong');
    const detail = document.createElement('p');
    title.textContent = !selected ? 'Start with your inverter brand.' : info ? `${selected}: ${info.title}` : 'Let SolarBoss check this combination.';
    detail.textContent = !selected ? 'We’ll show the available compatibility guidance. Your exact model still needs checking.' : info ? info.detail : 'Send us your exact inverter model and firmware before purchase. We cannot confirm compatibility from the brand name alone.';
    result.replaceChildren(title, detail);
    if (info && info.url && /^https:\/\//.test(info.url)) {
      const source = document.createElement('a');
      source.href = info.url; source.target = '_blank'; source.rel = 'noopener'; source.textContent = 'View compatibility source ↗';
      result.append(source);
    }
    const message = 'Please check Easyway UNIV-16kWh(WP) compatibility with my inverter: ' + (selected || 'brand not known') + (model.value.trim() ? ' — ' + model.value.trim() : '') + '. Please confirm the exact model, firmware and communication settings before I purchase.';
    root.querySelector('#ew-request-body').value = message;
  }
  root.querySelectorAll('[data-inverter-brand]').forEach(link=>link.addEventListener('click',()=>{
    brand.value=link.dataset.inverterBrand;
    update();
  }));
  brand.addEventListener('change', update);
  model.addEventListener('input', update);
  update();
})();
